//直播间的接口

import { ApiNetWork } from "@/network/apiNet/apiNet";

//房间id获取数据
export function getRoomData(data: any) {
  if (data.room_id == undefined) {
    return;
  }
  return ApiNetWork.get("app/encryptionHostInfo", data);
}

//房间id获取数据
export function getMatchInfo(data: any) {

  return ApiNetWork.get("app/encryptionMatchInfo", data);
}

//比赛id和比赛type获取数据
export function getMatchData(data: any) {
  return ApiNetWork.get("app/encryptionMatchDetail", data);
}

//比赛id和比赛type获取分析数据
export function getMatAnalysis(data: any) {
  return ApiNetWork.get("app/encryptionAnalysis", data);
}

//比赛id和比赛type获取指数
export function getMatchZhishu(data: any) {
  return ApiNetWork.get("app/encryptionGetHistory", data);
}

//清原去获取数据
export function getMatchUrlData(data: any) {
  return ApiNetWork.get("app/encryptionHostMatch", data);
}

// 房间直播数据
export function encryptionHostLive() {
  return ApiNetWork.get("app/encryptionHostLive");
}

// 赛况数据
export function encryptionDetailLive(data: any) {
  return ApiNetWork.get("app/encryptionDetailLive", data);
}

// 阵容数据
export function encryptionMatchLineUp(data: any) {
  return ApiNetWork.get("app/encryptionMatchLineUp", data);
}

// 球员统计数据
export function encryptionPlayerStats(data: any) {
  return ApiNetWork.get("app/encryptionPlayerStats", data);
}

// 积分任务上报
export function userLookOrSend(data: any) {
  return ApiNetWork.get("app/userLookOrSend", data);
}

//通过比赛type和id查询直播间，这个是外部进入直播间的时候用
export function MatchCheckHost(data: any) {
  console.log(data);

  return ApiNetWork.get("app/encryptionMatchCheckHost", data);
}

export function MatchCheckHostOther(data: any) {
  return ApiNetWork.get("app/encryptionMatchCheckHostOther", data);
}

//根据id获取mp4
export function getPlayMp4(data: any) {
  return ApiNetWork.get("app/getCustomVideoUrl", data);
}

export function encryptionLiveInfo(data: any) {
  return ApiNetWork.get("app/encryptionLiveInfo", data);
}

//获取转化号QA库
export function encryptionGetQAList(data:any) {
  return ApiNetWork.get("app/v1/encryptionSimpleQA", data);
}
